"use client"

import { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { getSettings, getPathOfStatic } from "../../utils"
import { apiClient } from "../../api/client"
import Timer from "../components/timer"
import { useLanguage } from "../../../../../contexts/LanguageContext"
import pl from "../../../../../contexts/pl"

const speeds = [0, 0.8, 1.3, 1.5];

const tell = (number, count, speed, player) => {
  if (count > 3 || speed < speeds[count]) return
  player.src = getPathOfStatic("/voices/" + localStorage.getItem("language") + "/" + number + ".mp3")
  player.volume = 1
  try {
    player.play()
  } catch (e) {
    // Handle audio play error
  }
}

const Training = ({ onFinish, onNext, player }) => {
  const { t } = useLanguage()
  const [step, setStep] = useState(0);
  const [number, setNumber] = useState("");
  const [result, setResult] = useState(0);
  const [done, setDone] = useState(false);
  const [displayNumbers, setDisplayNumbers] = useState(true);
  const [showResult, setShowResult] = useState(false);
  const [hideNumber, setHideNumber] = useState(false);

  const timerRef = useRef(null)
  const answerRef = useRef(null)

  const settings = getSettings("trainer");

  const getNextNumber = async (player) => {
    const numberStep = Math.floor(step / 2);
    try {
      const nextNumber = await apiClient.getNextNumber(numberStep, result, settings);
      const newResult = eval("result" + nextNumber);
      setNumber(nextNumber);
      setResult(newResult);
      tell(nextNumber, settings.count, settings.speed, player);
    } catch (error) {
      console.error("Failed to get next number:", error);
      // Handle error (e.g., show an error message to the user)
    }
  }

  const go = () => {
    setStep(prev => prev + 1);
  }

  useEffect(() => {
    if (!showResult) {
      timerRef.current = setTimeout(displayNumbers ? go : checkResult,
        !displayNumbers ? settings.time * 1000 :
          step % 2 === 1 ? 100 : settings.speed * 1000
      )
    }
    return () => {
      reset()
    }
  }, [step, displayNumbers, showResult]);

  useEffect(() => {
    if (done) {
      setShowResult(true);
      setDisplayNumbers(false);
    } else if (settings.steps <= step / 2) {
      setDisplayNumbers(false);
      setHideNumber(false);
    } else if (step % 2 === 0) {
      setHideNumber(false);
      if (player) {
        getNextNumber(player);
      }
    } else {
      setHideNumber(true);
      setNumber("")
    }
  }, [step, done, player]);

  const reset = () => {
    clearTimeout(timerRef.current);
  }
  const isSuccess = Number(answerRef.current?.value) === Number(result)

  const checkResult = () => {
    clearTimeout(timerRef.current);
    setDone(true);

    player.src = getPathOfStatic("/sounds/" + (Number(answerRef.current?.value) !== Number(result) ? "no" : "") + "success.mp3");
    player.volume = 1
    try {
      player.play()
    } catch (e) {
      // Handle audio play error
    }
  }

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      checkResult()
    }
  }

  return (
    <div>
      <h2>{t("performExercise")}</h2>
      <section>
        {hideNumber ? null : displayNumbers ? (
          <div className="example">{number}</div>
        ) : showResult ? (
          <div>
            <div className="answerIcon">
              <img
                alt=""
                src={getPathOfStatic(`/img/smiles/${isSuccess ? "cool" : "hm"}.png`)}
                width="400"
                height="266"
              />
            </div>
            <div className={`${isSuccess ? "" : "no"}success`}>{isSuccess ? t("correct") : t("incorrect")}</div>
            <div className="success">
              {t("answer")}: {result}
            </div>
          </div>
        ) : (
          <div className="answer">
            <div>{t("yourAnswer")}</div>
            <div>
              <input ref={answerRef} className="answer" autoFocus={true} type="number" onKeyDown={handleKeyDown} />
            </div>
            <Timer time={settings.time} />
          </div>
        )}
      </section>
      <footer>
        <button onClick={() => onFinish()}>
          <div>{t("settings")}</div>
        </button>
        {showResult && (
          <button onClick={() => onNext()}>
            <div>{t("continue")}</div>
          </button>
        )}
      </footer>
    </div>
  )
}

Training.propTypes = {
  onFinish: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
}

export default Training;
